import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GroupsService } from '../services/groups.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../services/user.service';

@Component({
    template: `
        <mat-card [formGroup]="form">
            <mat-card-header>
                <h2>Create Group</h2>
            </mat-card-header>
            <mat-card-content style="padding: 25px;">
                <div fxLayout="column" style="height: 100%">
                    <group-editor-basic [form]="form"></group-editor-basic>                
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="save()">Save</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class GroupCreateComponent {
    form: FormGroup;
    
    constructor(fb: FormBuilder,
                private route: ActivatedRoute, 
                private router: Router,
                private snackBar: MatSnackBar, 
                private groupService: GroupsService,
                private userService: UserService) {
        this.form = fb.group({
            name: ['', Validators.required],
            description: [],
            allowUsersToJoin: [false],
        });
    }

    save() {
        const user = this.userService.getCurrentUser();
        const newGroup = Object.assign({}, this.form.value, {creatorId: user.id });
        this.form.disable();
        this.groupService.saveGroup(newGroup)
        .subscribe(
            group => {
                this.snackBar.open(`${group.name} has been created.`, 'OK', { duration: 3000});
                this.router.navigate(['../', group.id], { relativeTo: this.route });
            },
            () => {
                this.snackBar.open(`Unable to create the group, please try again.`, 'OK', { duration: 3000});
                this.form.enable();
            }
        );
    }
}